export default __webpack_public_path__ + "static/taskdeploy3-06cf75c41984c4aa4555357d63f0a55a.png";